import { useCallback } from "react";
import {
  BitcoinSVG,
  EthereumSVG,
  CeloSVG,
  UsdtSVG,
  UsdcSVG,
  StellarSVG,
  RippleSVG,
  CeurSVG,
  CusdSVG,
  NairaSVG,
  CedisSVG,
  KenyaSVG,
  MaticSVG,
  PyusdSVG,
  BeninSVG,
  CameroonSVG,
  CongoSVG,
  LiskSVG,
} from "assets";
import { useColorModeValue, Icon } from "@chakra-ui/react";

// import toPrecision from "util/toPrecision";
// import formatter from "util/formatter";
// import constants from "config/constant";

export type SupportedCoinType =
  | "ngn"
  | "ghs"
  | "kes"
  | "btc"
  | "tbtc"
  | "eth"
  | "teth"
  | "usdc"
  | "usdt"
  | "celo"
  | "ceur"
  | "cusd"
  | "xrp"
  | "matic"
  | "xlm"
  | "pyusd"
  | "cdf"
  | "xaf"
  | "xof"
  | "lisk";

type CoinInfoType = {
  label: string;
  icon: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;
};

export const RippleIcon = (props: any) => {
  const rippleColor = useColorModeValue("#23292f", "white");
  return <Icon as={RippleSVG} color={rippleColor} {...props} />;
};

export default function useCoin(coin?: SupportedCoinType) {
  const getWalletInfo = useCallback((coin: SupportedCoinType) => {
    const map: Record<SupportedCoinType, CoinInfoType> = {
      ngn: { label: "Nigerian Naira", icon: NairaSVG },
      ghs: { label: "Ghanaian Cedis", icon: CedisSVG },
      kes: { label: "Kenyan Shillings", icon: KenyaSVG },
      btc: { label: "Bitcoin", icon: BitcoinSVG },
      tbtc: { label: "Bitcoin", icon: BitcoinSVG },
      eth: { label: "Ethereum", icon: EthereumSVG },
      teth: { label: "Ethereum", icon: EthereumSVG },
      usdc: { label: "USDC", icon: UsdcSVG },
      usdt: { label: "USD Tether", icon: UsdtSVG },
      celo: { label: "Celo", icon: CeloSVG },
      cusd: { label: "cUSD", icon: CusdSVG },
      ceur: { label: "cEUR", icon: CeurSVG },
      xrp: { label: "Ripple", icon: RippleIcon },
      xlm: { label: "Stellar", icon: StellarSVG },
      matic: { label: "Polygon", icon: MaticSVG },
      pyusd: { label: "PYUSD", icon: PyusdSVG },
      cdf: { label: "Congolese Franc", icon: CongoSVG },
      xaf: { label: "Central African Franc", icon: CameroonSVG },
      xof: { label: "West African Franc", icon: BeninSVG },
      lisk: { label: "Lisk", icon: LiskSVG },
    };

    return map[coin ?? "ngn"];
  }, []);

  const info = getWalletInfo(coin ?? "ngn");

  return { ...info, getWalletInfo };
}
